import { cva, VariantProps } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';
import { InputState } from '../../../util/types';
import { commonVariants } from '../styles.ts';

export interface TextareaAtomProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  state?: InputState;
  rows?: number;
  cols?: number;
  isResizable?: boolean;
}

const inputVariants = cva(
  ['preflight', 'ds-form-input', 'ds-rounded', 'ds-p-2', '!ds-border', '!ds-font-sans'],
  commonVariants
);

interface InputVariants extends VariantProps<typeof inputVariants> {}
const input = (variants: InputVariants) => twMerge(inputVariants(variants));

const TextareaAtom = ({
  state = 'default' as InputState,
  rows = 2,
  cols = 50,
  isResizable = true,
  disabled = false,
  ...props
}: TextareaAtomProps) => {
  return (
    <textarea
      aria-invalid={state == 'error'}
      rows={rows}
      cols={cols}
      readOnly={disabled}
      className={input({ disabled, state })}
      style={{
        resize: isResizable ? 'both' : 'none'
      }}
      {...props}
    />
  );
};

export default TextareaAtom;
